import React from "react";
import ReactSelect from 'react-select';
import { CalcRow, frequencyOptions } from './helpers';
import { parseSmallAmount, validAmount } from './../common-helpers';
interface Props {
	updateStateHandler: ( category: string, sectionIndex: number, rowIndex: number, row: CalcRow) => void,
	deleteRow: (category: string, sectionIndex: number, rowIndex: number) => void,
	category: string,
	rowIndex: number,
	row: CalcRow,
	sectionIndex: number,
	selectedBudgetPeriod: number,
};

const Row: React.FC<Props> = ({category, rowIndex, row, sectionIndex, selectedBudgetPeriod, updateStateHandler, deleteRow}) => {
	const updateAmount: React.ChangeEventHandler<HTMLInputElement> = ({ currentTarget }) => {
		let { value: newValue } = currentTarget;
		if (!newValue.length) { return; }
		updateStateHandler(category, sectionIndex, rowIndex, { label: row.label, value: parseSmallAmount(newValue, 16), frequency: row.frequency });
	};
	const updateLabel: React.ChangeEventHandler<HTMLInputElement> = ({ currentTarget }) => {
		let { value: newValue } = currentTarget;
		if (!newValue.length) { return; }
		updateStateHandler(category, sectionIndex, rowIndex, { label: newValue, value: row.value, frequency: row.frequency });
	};

	const deleteRowHandler = (event: React.SyntheticEvent<HTMLButtonElement>) => {
		event.preventDefault();
		deleteRow(category, sectionIndex, rowIndex);
	};

	return (
		<div className="budget-row">
			<div className="budget-row-delete-button">
				<button type="button" name={row.label} data-testid={`delete-row-${category}-${sectionIndex}-${rowIndex}`} onClick={deleteRowHandler}>x</button>
			</div>
			<div className="budget-row-label">
				<input
					className="budget-row-label-input"
					onChange={updateLabel}
					type="text"
					value={row.label}
				/>
			</div>
			<div className="budget-row-center-inputs">
				<input
					className="budget-row-input_value"
					onChange={updateAmount}
					placeholder="$0"
					inputMode="numeric"
					title={row.label}
					type="text"
					value={row.value}
				/>
				<ReactSelect
						instanceId="period"
						name="period"
						options={frequencyOptions}
						defaultValue={[{label: "Monthly", value: 12}]}
						value={frequencyOptions.filter(({ value }) => value === row.frequency)}
						onChange={(newValue, actionMeta) => {
							updateStateHandler(category, sectionIndex, rowIndex, { label: row.label, value: row.value, frequency: newValue ? newValue.value : 12 });
						}}
						isSearchable={true}
						className="budget-row-period-select"
					/>
				</div>
			<div className="budget-row-total-amount">
				<span className="budget-row-total-amount_label">Amount for budget period:</span>
				<span>{ parseSmallAmount((+validAmount(row.value) * (row.frequency/12)*selectedBudgetPeriod).toString()) }</span>
			</div>
		</div>
	);
};

export default Row;
